import _ from "lodash";
import { Group, Select, NumberInput } from "@mantine/core";
import RemoteSelect2 from "./remoteSelect2";
import { useForceUpdate } from "@mantine/hooks";

const BundleProductRow = ({ item, form, name, index }) => {
  const forceUpdate = useForceUpdate();

  return (
    <Group wrap="noWrap" grow>
      <RemoteSelect2
        label="Product"
        apiEntity="product"
        labelField="name"
        valueField="_id"
        labelRender={(data) => `${data.name}`}
        multiple={false}
        searchFields={["code name cname"]}
        placeholder="Product"
        clearable={true}
        value={item.content["product"]}
        onDataChange={(data) => {
          item.content["product"] = data?._id;
          item.content["quantity"] = 1;
          forceUpdate();
        }}
        preQuery={{ status: "ACTIVE" }}
        sort={{
          by: "name",
          order: "asc",
        }}
        pageSize={100}
      />

      <NumberInput
        {...form.getInputProps(`${name}.${index}.quantity`)}
        label="Quantity"
        placeholder="Enter Quantity"
        thousandSeparator=","
        prefix=""
        required
      />
    </Group>
  );
};

export default BundleProductRow;
